import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit'
import { API_CONFIG, API_LIST } from '../../Constants/ApiDefinations'
import { CreateMastersData, LanguagesListResponse } from '../../Models'
import mainApiService from '../../Services'
import { setLoader } from './loader.slice'

interface LanguagesState {
  languageData: LanguagesListResponse | null
}

const initialState: LanguagesState = {
  languageData: null,
}

const languagesSlice = createSlice({
  name: 'languages',
  initialState,
  reducers: {
    setLanguagesData: (state, action) => {
      state.languageData = action?.payload ? action.payload : null
    },
  },
})

export const changeLanguageStatus = createAsyncThunk(
  'languages/changeStatus',
  async (data: { id: string; status: string }, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = API_CONFIG(
      API_LIST.SYSTEM_CONFIGURATION.CONFIG_LIST,
      null,
      null,
      `keyName=LANGUAGES&${data}`,
    )
    const result = await mainApiService(requestedData)
    dispatch(setLoader(false))
    return result
  },
)

export const { setLanguagesData } = languagesSlice.actions

const languagesSelector = (state: any) => state.languages

export const selectLanguageData = createSelector(languagesSelector, (state) => state.languageData)

export const createLanguageService = createAsyncThunk(
  'languages/create',
  async (payload: CreateMastersData, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = API_CONFIG(
      API_LIST.MASTER_APIS.ADD_SYSTEM_CONFIG,
      {
        value: { key: payload.key, status: payload.status, value: payload.value },
        master: 'LANGUAGES',
      },
      {
        type: 'LANGUAGES',
      },
    )
    const data = await mainApiService(requestedData)
    dispatch(setLoader(false))
    return data
  },
)

export const editLanguageService = createAsyncThunk(
  'languages/editLanguage',
  async (payload: CreateMastersData, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = API_CONFIG(
      API_LIST.MASTER_APIS.ADD_SYSTEM_CONFIG,
      {
        value: { key: payload.key, status: payload.status, value: payload.value },
        master: 'LANGUAGES',
        systemConfigId: payload?.id,
      },
      {
        type: 'LANGUAGES',
      },
    )

    const data = await mainApiService(requestedData)
    dispatch(setLoader(false))
    return data
  },
)

export default languagesSlice
